import { defineConfig } from 'cva';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * A helper function to ensure that the custom font size classes are merged when using the `cva` utility.
 */
export const merge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'xxs',
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            'caption',
            'body-sm',
            'body-sm-compact',
            'body-md',
            'body-md-compact',
            'body-lg',
            'body-lg-compact',
            'heading-1',
            'heading-2',
            'heading-3',
            'heading-4',
            'display-xs',
            'display-sm',
            'display-md',
            'display-lg',
            'display-xl',
            'display-2xl',
          ],
        },
      ],
    },
  },
});

/**
 * A set of utilities for working with the design system theme in Tailwind CSS.
 */
export const { cva, cx, compose } = defineConfig({
  hooks: {
    onComplete: (className) => merge(className),
  },
});

export type { VariantProps } from 'cva';
